import { gsap } from 'gsap';

export default class CtaTabs {
    constructor() {
        this.init();
    }

    init() {
        this.tabs = document.querySelectorAll('.subitem');
        this.contents = document.querySelectorAll('.subitem-content');

        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => this.handleTabClick(tab));
        });

        // Set the first tab and content as active if none are active
        const activeContent = document.querySelector('.subitem-content.active');
        if (!activeContent && this.contents.length > 0) {
            const firstContent = this.contents[0];
            const firstTab = this.tabs[0];

            firstContent.classList.add('active');
            firstContent.style.opacity = 1;

            if (firstTab) {
                firstTab.classList.add('active');
            }
        }
    }

    handleTabClick(tab) {
        const targetId = tab.getAttribute('data-subitem-id');
        const targetContent = document.getElementById(targetId);

        if (!targetContent) {
            return;
        }

        // Hide all contents
        this.contents.forEach(content => {
            if (content !== targetContent) {
                gsap.to(content, {
                    duration: 0,
                    opacity: 0,
                    onComplete: () => {
                        content.classList.remove('active');
                    }
                });
            } else {
                // Show the target content
                gsap.to(targetContent, {
                    duration: 0.5,
                    opacity: 1,
                    onStart: () => {
                        targetContent.classList.add('active');
                    }
                });
            }
        });

        // Update tab classes
        this.tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
    }
}
